import { InjectionToken } from '@angular/core';

export const SN_API_URL = new InjectionToken<string>('SN_API_URL');
export const SN_SECONDARY_API_URL = new InjectionToken<string>('SN_SECONDARY_API_URL');
